var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M42 38h9.841v35.429H42zM59.715 38h9.841v35.429h-9.841z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEyIiBoZWlnaHQ9IjExMiIgdmlld0JveD0iMCAwIDExMiAxMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjU2IiBjeT0iNTYiIHI9IjU2IiBmaWxsPSIjZmZmZmZmIi8+CjxyZWN0IHg9IjQyIiB5PSIzOCIgd2lkdGg9IjkuODQxMzEiIGhlaWdodD0iMzUuNDI4NyIgZmlsbD0iIzIzMUYyMCIvPgo8cmVjdCB4PSI1OS43MTQ4IiB5PSIzOCIgd2lkdGg9IjkuODQxMzEiIGhlaWdodD0iMzUuNDI4NyIgZmlsbD0iIzIzMUYyMCIvPgo8L3N2Zz4K";
export { SvgPauseCursor as ReactComponent };